import { DEFAULT_ALLOWED_DEVICE_CODE_LENGTH } from "@jti/fe-common";
import { useAemModel } from "../../contexts/AemModelContext";
export const useDeviceRegistrationModel = () => {
    var _a;
    const { deviceRegistration } = useAemModel();
    const isDeviceRegistrationByLeafletEnabled = (deviceRegistration === null || deviceRegistration === void 0 ? void 0 : deviceRegistration.isDeviceRegistrationByLeafletEnabled) || false;
    const isDeviceRegistrationMandatory = (deviceRegistration === null || deviceRegistration === void 0 ? void 0 : deviceRegistration.isDeviceRegistrationMandatory) || false;
    const isScanDeviceQrEnabled = (deviceRegistration === null || deviceRegistration === void 0 ? void 0 : deviceRegistration.isScanDeviceQrEnabled) || false;
    return {
        isDeviceRegistrationByLeafletEnabled,
        isDeviceRegistrationMandatory,
        isScanDeviceQrEnabled,
        deviceCodeLength: (_a = deviceRegistration === null || deviceRegistration === void 0 ? void 0 : deviceRegistration.deviceCodeLength) !== null && _a !== void 0 ? _a : DEFAULT_ALLOWED_DEVICE_CODE_LENGTH,
    };
};
